module.exports = __webpack_public_path__ + "img/private.289dba5c.png";